<template>
  <v-card light>
    <v-card-title class="grey lighten-4">
      <span class="primary--text" v-text="__('tip')" />
      <v-spacer />
      {{ newValue | currency }}
    </v-card-title>
    <h-calculator
      v-model="amount"
      light
    />
    <v-card-actions>
      <v-btn
        text
        color="grey darken-1"
        v-text="__('cancel')"
        @click="cancel()"
      />
      <v-spacer />
      <v-btn
        :disabled="disabled"
        text
        color="primary"
        v-text="__('done')"
        @click="done()"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
  import Currenciable from '@/Mixins/Currenciable'
  import I18n from '@/Mixins/I18n'
  import HCalculator from '@/Components/Calculator'

  export default {
    mixins: [
      Currenciable,
      I18n,
    ],

    components: {
      HCalculator,
    },

    props: {
      value: {
        required: true,
        type: Number,
      },
    },

    data: () => ({
      amount: '0',
    }),

    computed: {
      newValue () {
        return parseInt(this.amount) / 100
      },
      disabled () {
        return this.value.equalTo(0) && this.newValue.equalTo(0)
      },
    },

    watch: {
      value () {
        this.init()
      },
    },

    methods: {
      init () {
        this.amount = String(Math.round(this.value * 100))
      },
      cancel () {
        this.init()
        this.$emit('close')
      },
      done () {
        this.$emit('input', this.newValue)
        this.$emit('close')
      },
    },
  }
</script>
